import React from "react";
import './StudentWork.css';

class StudentWork extends React.Component {
    render() {
        return (
            <article className="article br3 ba b--black-10 w-100 w-50-m w-50-l mw7 shadow-5 center">
                <main className="pa4 black-80">
                    <div className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                            <div className='legend center'>
                                <legend className="f1 fw6 ph0 mh0">الشغل للطلاب اثناء الدراسة فى المانيا</legend>
                            </div>
                            <hr/>

                            <div className="ui form ma0">
                                <div className="fields">
                                    <h3>
                                        السلام عليكم.. 
                                        <br/>
                                        السؤال الأهم و اللى بيشغل تفكير كل واحد فينا و عايز يسافر!
                                        <br/>
                                        هل اقدر اشتغل و انا طالب؟ 
                                        <br/>
                                        في البوست دة هتلاقى إجابة لمعظم الاسئلة اللى بتفكر فيها 
                                        <br/>
                                        - هل الطالب يقدر يشتغل في المانيا؟ 
                                        <br/>
                                        القانون بيسمح للطلاب اللى من خارج الاتحاد الاوروبى ان هما يشتغلوا 960ساعة سنويا
                                        <br/>
                                        "120 يوم فول تايم"
                                        <br/>
                                        "240 يوم بارت تايم" 
                                        <br/>
                                        - اقدر اشتغل بعد قد ايه من وصولى المانيا ؟
                                        <br/>
                                        لما تاخد تصريح العمل من مكتب الأجانب و دة غالبا بيبقا بعد 3 شهور في معظم المدن و ممكن بعد شهر .. انت و نصيبك
                                        <br/>
                                        - هل أقدر أزود عدد الساعات لو خلصت؟ 
                                        <br/>
                                        دى بترجع لمكتب الأجانب وممكن يوافقوا وممكن لاء
                                        <br/>
                                        - طب سعر ساعة العمل ؟
                                        <br/>
                                        سعر ساعة العمل للطلاب ف ان الحد الأدنى ميقلش 
                                        عن ٩ يورو
                                        <br/>
                                        و احيانا فى بعض الوظائف بيوصل ل 15 / 13 يورو فى الساعة
                                        <br/>
                                        - طب بدفع ضرائب ؟
                                        اة بتدفع ضرائب لو المبلغ زاد عن 450 يورو فى الشهر و بترجعها تانى في اخر السنة عادى لانك لسا طالب
                                        <br/>
                                        - ايه هو الشغل الأسود ؟
                                        <br/>
                                        يعنى هتشتغل من غير ما الحكومة تعرف و لو اتمسكت فهيتطبق عليك غرامة كبيرة فالافضل بلاش تمشى في السكة دى
                                        <br/>
                                        - اقدر اشتغل في مجالى لو لسا بدرس ؟ 
                                        <br/>
                                        بترجع لصاحب العمل و ممكن يوافق و ممكن لاء و حتى لو وافق فهيتطبق عليك قانون العمل كطالب
                                        <br/>
                                        - اقدر اصرف على نفسى لو اشتغلت ؟ 
                                        <br/>
                                        اة تقدر تصرف على نفسك لو اشتغلت فلو هتحسبها لو اشتغلت كل ساعات العمل
                                        <br/>
                                        بس لازم تظبط وقتك طبعا لان الموضوع مش سهل ما بين دراسة و شغل" بالنسبة للتجارب"
                                        <br/>
                                        - هل طلاب اللغة و التحضيرية يقدروا يشتغلوا ؟ 
                                        <br/>
                                        بالنسبة للقانون فطلاب اللغة يسمح ليهم ان هما يشتغلوا فقط فى الاجازات اللى ما بين الكورسات مش اخر الاسبوع" وممكن تختلف من مدينة لمدينة"
                                        <br/>
                                        اما  التحضيرية فليهم الحق ان هما يشتغلوا ما بين الترمات فقط 
                                        <br/>
                                        "وممكن تختلف من مدينة لمدينة"
                                        <br/>
                                        - طب ايه نظام طلاب البكالوريوس و الماستر ؟ 
                                        <br/>
                                        طلاب البكالوريوس و الماستر ليهم الحق ان هما يشتغلوا فى اى وقت مادام بيدرسوا فى الجامعة
                                        <br/>
                                        - طب هل فيه شغل فى المانيا للطلاب ؟
                                        <br/>
                                        اة فيه شغل للطلاب بس بترجع للمدينة و لغتك .. كل ما المدينة كبيرة فكل ما الشغل فيها بيزيد و فيه مدن برضه مش معروفة و هتلاقى فيها شغل عادى
                                        <br/>
                                        و دى فيديوهات هتفيدكم اكتر و هتعرفوا منها طبيعة الشغل و ازاى تبحثوا عن الشغل .. هتستفادوا منها
                                        <br/>
                                        <br/>
                                        <div className='lft'>
                                            - محمد عبدالسلام 
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://youtu.be/tg3ZCDMr7WM'>youtu.be/tg3ZCDMr7WM</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://youtu.be/imZIM5Rg2gk'>youtu.be/imZIM5Rg2gk</a>
                                            <br/>
                                            <br/>
                                            - على منصور 
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://youtu.be/-6JaRFGbPuc'>youtu.be/-6JaRFGbPuc</a>
                                            <br/>
                                            <br/>
                                            - محمود سمير
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/100006402372164/videos/2022958051260921/?video_source=permalink'>facebook.com/../videos/2022958051260921</a>
                                            <br/>
                                            <br/>
                                            - مروان احمد
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/posts/967356613643059/'>facebook.com/../../posts/967356613643059</a>
                                        </div>
                                        ______________________________________
                                        <br/>
                                        معلومات اكتر هتلاقيها في اللينكات دى
                                        <div className='lft'>
                                            <a target='_blank' rel='noreferrer' href='http://www.internationale-studierende.de/en/prepare_your_studies/financing/jobbing/'>internationale-studierende.de/en/../financing/jobbing</a>
                                        <br/>
                                        <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.study-in-germany.de/en/germany/everyday-life/work/'>study-in-germany.de/en/germany/everyday-life/work</a>
                                        <br/>
                                        <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.justlanded.com/english/Germany/Germany-Guide/Jobs/Student-jobs/'>justlanded.com/english/Germany/Germany-Guide/Jobs/Student-jobs</a>
                                        <br/>
                                        <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.daad.de/en/study-and-research-in-germany/first-steps-germany/side-jobs/'>daad.de/en/study-and-research-in-germany/first-steps-germany/side-jobs</a>
                                        <br/>
                                        <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.bachelorsportal.com/articles/1835/what-are-my-student-job-options-if-i-want-to-study-a-bachelors-in-germany.html'>bachelorsportal.com/articles/1835/what-are-my-student-job-options-if-i-want-to-study-a-bachelors-in-germany.html</a>
                                        </div>
                                    </h3>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </main>
            </article>
        );
    }
}

export default StudentWork;
